// extracted by mini-css-extract-plugin
export default {"fileRendererViewport":"RichDiff-module__fileRendererViewport__bCfsBeG","fileRendererIframe":"RichDiff-module__fileRendererIframe__bL7zS1g"};